// todo ricardo remove this (Primary Key) stuff, and just add that on the UI if its ID. Another possibility is an isPrimaryKey: true field or something. But just don't put it on the name field.

export const actionModels = {
  'hris.employee': {
    label: 'HRIS / Employee',
    nickname: 'Employee',
    nicknamePlural: 'Employees',
    category: 'HR, Payroll, and Directory (HRIS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' }, //
      { key: 'firstName', name: 'First Name' },
      { key: 'lastName', name: 'Last Name' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' }
    ]
  },

  'hris.company': {
    label: 'HRIS / Company',
    nickname: 'Company',
    nicknamePlural: 'Companies',
    category: 'HR, Payroll, and Directory (HRIS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' }, //
      { key: 'displayName', name: 'Display Name' },
      { key: 'legalName', name: 'Legal Name' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' }
    ]
  },
  'hris.payroll': {
    label: 'HRIS / Payroll',
    nickname: 'Payroll',
    nicknamePlural: 'Payrolls',
    category: 'HR, Payroll, and Directory (HRIS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'employee', name: 'Employee' },
      { key: 'state', name: 'State' },
      { key: 'type', name: 'Type' },
      { key: 'startDate', name: 'Start Date' },
      { key: 'endDate', name: 'End Date' },
      { key: 'checkDate', name: 'Check Date' },
      { key: 'grossPay', name: 'Gross Pay' },
      { key: 'netPay', name: 'Net Pay' }
    ]
  },
  'hris.timesheet': {
    label: 'HRIS / Timesheet',
    nickname: 'Timesheet',
    nicknamePlural: 'Timesheets',
    category: 'HR, Payroll, and Directory (HRIS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'updatedAt', name: 'Updated At' },
      { key: 'employee', name: 'Employee' },
      { key: 'hoursWorked', name: 'Hours Worked' },
      { key: 'startTime', name: 'Start Time' },
      { key: 'endTime', name: 'End Time' }
    ]
  },
  'hris.bankInfo': {
    label: 'HRIS / Bank Info',
    nickname: 'Bank Info',
    nicknamePlural: 'Bank Infos',
    category: 'HR, Payroll, and Directory (HRIS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'employee', name: 'Employee' },
      { key: 'accountNumber', name: 'Account Number' },
      { key: 'routingNumber', name: 'Routing Number' },
      { key: 'bankName', name: 'Bank Name' },
      { key: 'accountType', name: 'Account Type' },
      { key: 'remoteCreatedAt', name: 'Remote Created At' }
    ]
  },
  'hris.benefits': {
    label: 'HRIS / Benefits',
    nickname: 'Benefit',
    nicknamePlural: 'Benefits',
    category: 'HR, Payroll, and Directory (HRIS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'employee', name: 'Employee' },
      { key: 'providerName', name: 'Provider Name' },
      { key: 'employeeContribution', name: 'Employee Contribution' },
      { key: 'companyContribution', name: 'Company Contribution' },
      { key: 'startDate', name: 'Start Date' },
      { key: 'endDate', name: 'End Date' },
      { key: 'employerBenefit', name: 'Employer Benefit' }
    ]
  },
  'hris.dependents': {
    label: 'HRIS / Dependents',
    nickname: 'Dependent',
    nicknamePlural: 'Dependents',
    category: 'HR, Payroll, and Directory (HRIS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'firstName', name: 'First Name' },
      { key: 'middleName', name: 'Middle Name' },
      { key: 'lastName', name: 'Last Name' },
      { key: 'relationship', name: 'Relationship' },
      { key: 'employee', name: 'Employee' },
      { key: 'dateOfBirth', name: 'Date of Birth' },
      { key: 'gender', name: 'Gender' },
      { key: 'phoneNumber', name: 'Phone Number' },
      { key: 'homeLocation', name: 'Home Location' },
      { key: 'isStudent', name: 'Is Student' },
      { key: 'ssn', name: 'SSN' }
    ]
  },
  'hris.employeePayrollRuns': {
    label: 'HRIS / Employee Payroll Runs',
    nickname: 'Employee Payroll Run',
    nicknamePlural: 'Employee Payroll Runs',
    category: 'HR, Payroll, and Directory (HRIS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'employee', name: 'Employee' },
      { key: 'payrollRun', name: 'Payroll Run' },
      { key: 'grossPay', name: 'Gross Pay' },
      { key: 'netPay', name: 'Net Pay' },
      { key: 'startDate', name: 'Start Date' },
      { key: 'endDate', name: 'End Date' },
      { key: 'checkDate', name: 'Check Date' },
      { key: 'earnings', name: 'Earnings' },
      { key: 'deductions', name: 'Deductions' },
      { key: 'taxes', name: 'Taxes' }
    ]
  },
  'hris.employerBenefits': {
    label: 'HRIS / Employer Benefits',
    nickname: 'Employer Benefit',
    nicknamePlural: 'Employer Benefits',
    category: 'HR, Payroll, and Directory (HRIS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'benefitPlanType', name: 'Benefit Plan Type' },
      { key: 'name', name: 'Name' },
      { key: 'description', name: 'Description' },
      { key: 'deductionCode', name: 'Deduction Code' }
    ]
  },
  'hris.employments': {
    label: 'HRIS / Employments',
    nickname: 'Employment',
    nicknamePlural: 'Employments',
    category: 'HR, Payroll, and Directory (HRIS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'employee', name: 'Employee' },
      { key: 'jobTitle', name: 'Job Title' },
      { key: 'payRate', name: 'Pay Rate' },
      { key: 'payPeriod', name: 'Pay Period' },
      { key: 'payFrequency', name: 'Pay Frequency' },
      { key: 'payCurrency', name: 'Pay Currency' },
      { key: 'payGroup', name: 'Pay Group' },
      { key: 'flsaStatus', name: 'FLSA Status' },
      { key: 'effectiveDate', name: 'Effective Date' },
      { key: 'employmentType', name: 'Employment Type' }
    ]
  },
  'hris.groups': {
    label: 'HRIS / Groups',
    nickname: 'Group',
    nicknamePlural: 'Groups',
    category: 'HR, Payroll, and Directory (HRIS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'parentGroup', name: 'Parent Group' },
      { key: 'name', name: 'Name' },
      { key: 'type', name: 'Type' },
      { key: 'isCommonlyUsedAsTeam', name: 'Is Commonly Used As Team' }
    ]
  },
  'hris.locations': {
    label: 'HRIS / Locations',
    nickname: 'Location',
    nicknamePlural: 'Locations',
    category: 'HR, Payroll, and Directory (HRIS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' },
      { key: 'phoneNumber', name: 'Phone Number' },
      { key: 'street1', name: 'Street 1' },
      { key: 'street2', name: 'Street 2' },
      { key: 'city', name: 'City' },
      { key: 'state', name: 'State' },
      { key: 'zipCode', name: 'Zip Code' },
      { key: 'country', name: 'Country' },
      { key: 'locationType', name: 'Location Type' }
    ]
  },
  'hris.payGroups': {
    label: 'HRIS / Pay Groups',
    nickname: 'Pay Group',
    nicknamePlural: 'Pay Groups',
    category: 'HR, Payroll, and Directory (HRIS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'payGroupName', name: 'Pay Group Name' }
    ]
  },
  'hris.payrollRuns': {
    label: 'HRIS / Payroll Runs',
    nickname: 'Payroll Run',
    nicknamePlural: 'Payroll Runs',
    category: 'HR, Payroll, and Directory (HRIS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'runState', name: 'Run State' },
      { key: 'runType', name: 'Run Type' },
      { key: 'startDate', name: 'Start Date' },
      { key: 'endDate', name: 'End Date' },
      { key: 'checkDate', name: 'Check Date' }
    ]
  },
  'hris.timeOff': {
    label: 'HRIS / Time Off',
    nickname: 'Time Off',
    nicknamePlural: 'Time Off',
    category: 'HR, Payroll, and Directory (HRIS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'employee', name: 'Employee' },
      { key: 'approver', name: 'Approver' },
      { key: 'status', name: 'Status' },
      { key: 'employeeNote', name: 'Employee Note' },
      { key: 'units', name: 'Units' },
      { key: 'amount', name: 'Amount' },
      { key: 'requestType', name: 'Request Type' },
      { key: 'startTime', name: 'Start Time' },
      { key: 'endTime', name: 'End Time' }
    ]
  },
  'hris.timeOffBalances': {
    label: 'HRIS / Time Off Balances',
    nickname: 'Time Off Balance',
    nicknamePlural: 'Time Off Balances',
    category: 'HR, Payroll, and Directory (HRIS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'employee', name: 'Employee' },
      { key: 'balance', name: 'Balance' },
      { key: 'used', name: 'Used' },
      { key: 'policyType', name: 'Policy Type' }
    ]
  },
  'hris.timesheetEntries': {
    label: 'HRIS / Timesheet Entries',
    nickname: 'Timesheet Entry',
    nicknamePlural: 'Timesheet Entries',
    category: 'HR, Payroll, and Directory (HRIS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'employee', name: 'Employee' },
      { key: 'hoursWorked', name: 'Hours Worked' },
      { key: 'startTime', name: 'Start Time' },
      { key: 'endTime', name: 'End Time' }
    ]
  },
  'accounting.customer': {
    label: 'Accounting / Customer',
    nickname: 'Customer',
    nicknamePlural: 'Customers',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'updatedAt', name: 'Updated At' },
      { key: 'name', name: 'Name' },
      { key: 'emailAddress', name: 'Email Address' },
      { key: 'taxNumber', name: 'Tax Number' },
      { key: 'status', name: 'Status' },
      { key: 'currency', name: 'Currency' },
      { key: 'address', name: 'Address' },
      { key: 'phoneNumber', name: 'Phone Number' }
    ]
  },
  'accounting.invoice': {
    label: 'Accounting / Invoice',
    nickname: 'Invoice',
    nicknamePlural: 'Invoices',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'type', name: 'Type' },
      { key: 'contact', name: 'Contact' },
      { key: 'number', name: 'Number' },
      { key: 'issueDate', name: 'Issue Date' },
      { key: 'dueDate', name: 'Due Date' },
      { key: 'paidOnDate', name: 'Paid On Date' },
      { key: 'currency', name: 'Currency' },
      { key: 'exchangeRate', name: 'Exchange Rate' },
      { key: 'subTotal', name: 'Sub Total' },
      { key: 'status', name: 'Status' },
      { key: 'totalTaxAmount', name: 'Total Tax Amount' },
      { key: 'totalAmount', name: 'Total Amount' }
    ]
  },
  'accounting.item': {
    label: 'Accounting / Item',
    nickname: 'Item',
    nicknamePlural: 'Items',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'updatedAt', name: 'Updated At' },
      { key: 'name', name: 'Name' },
      { key: 'status', name: 'Status' },
      { key: 'unitPrice', name: 'Unit Price' },
      { key: 'purchasePrice', name: 'Purchase Price' },
      { key: 'contact', name: 'Contact' },
      { key: 'purchaseTaxRate', name: 'Purchase Tax Rate' },
      { key: 'salesTaxRate', name: 'Sales Tax Rate' }
    ]
  },
  'accounting.payment': {
    label: 'Accounting / Payment',
    nickname: 'Payment',
    nicknamePlural: 'Payments',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'transactionDate', name: 'Transaction Date' },
      { key: 'contact', name: 'Contact' },
      { key: 'currency', name: 'Currency' },
      { key: 'exchangeRate', name: 'Exchange Rate' },
      { key: 'company', name: 'Company' },
      { key: 'totalAmount', name: 'Total Amount' },
      { key: 'type', name: 'Type' }
    ]
  },
  'accounting.purchaseOrder': {
    label: 'Accounting / Purchase Order',
    nickname: 'Purchase Order',
    nicknamePlural: 'Purchase Orders',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'status', name: 'Status' },
      { key: 'issueDate', name: 'Issue Date' },
      { key: 'purchaseOrderNumber', name: 'Purchase Order Number' },
      { key: 'customer', name: 'Customer' },
      { key: 'memo', name: 'Memo' },
      { key: 'totalTaxAmount', name: 'Total Tax Amount' },
      { key: 'totalAmount', name: 'Total Amount' },
      { key: 'currency', name: 'Currency' },
      { key: 'exchangeRate', name: 'Exchange Rate' },
      { key: 'lineItems', name: 'Line Items' }
    ]
  },
  'accounting.salesOrder': {
    label: 'Accounting / Sales Order',
    nickname: 'Sales Order',
    nicknamePlural: 'Sales Orders',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'orderNumber', name: 'Order Number' },
      { key: 'status', name: 'Status' },
      { key: 'customer', name: 'Customer' },
      { key: 'issueDate', name: 'Issue Date' },
      { key: 'shipDate', name: 'Ship Date' },
      { key: 'currency', name: 'Currency' },
      { key: 'exchangeRate', name: 'Exchange Rate' },
      { key: 'totalTaxAmount', name: 'Total Tax Amount' },
      { key: 'totalAmount', name: 'Total Amount' },
      { key: 'lineItems', name: 'Line Items' },
      { key: 'memo', name: 'Memo' },
      { key: 'shippingAddress', name: 'Shipping Address' },
      { key: 'billingAddress', name: 'Billing Address' }
    ]
  },
  'accounting.settlement': {
    label: 'Accounting / Settlement',
    nickname: 'Settlement',
    nicknamePlural: 'Settlements',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'updatedAt', name: 'Updated At' },
      { key: 'type', name: 'Type' },
      { key: 'StartDate', name: 'Start Date' },
      { key: 'EndDate', name: 'End Date' },
      { key: 'depositDate', name: 'Deposit Date' },
      { key: 'unitsPurchased', name: 'Units Purchased' },
      { key: 'unitAmount', name: 'Unit Amount' },
      { key: 'totalAmount', name: 'Total Amount' },
      { key: 'currency', name: 'Currency' },
      { key: 'orderId', name: 'Order ID' }
    ]
  },
  'accounting.transaction': {
    label: 'Accounting / Transaction',
    nickname: 'Transaction',
    nicknamePlural: 'Transactions',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'updatedAt', name: 'Updated At' },
      { key: 'type', name: 'Type' },
      { key: 'number', name: 'Number' },
      { key: 'transactionDate', name: 'Transaction Date' },
      { key: 'contact', name: 'Contact' },
      { key: 'totalAmount', name: 'Total Amount' },
      { key: 'currency', name: 'Currency' },
      { key: 'exchangeRate', name: 'Exchange Rate' },
      { key: 'lineItems', name: 'Line Items' }
    ]
  },
  'accounting.vendor': {
    label: 'Accounting / Vendor',
    nickname: 'Vendor',
    nicknamePlural: 'Vendors',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'updatedAt', name: 'Updated At' },
      { key: 'name', name: 'Name' },
      { key: 'emailAddress', name: 'Email Address' },
      { key: 'taxNumber', name: 'Tax Number' },
      { key: 'status', name: 'Status' },
      { key: 'currency', name: 'Currency' },
      { key: 'address', name: 'Address' },
      { key: 'phoneNumber', name: 'Phone Number' }
    ]
  },
  'accounting.accountingPeriod': {
    label: 'Accounting / Accounting Period',
    nickname: 'Accounting Period',
    nicknamePlural: 'Accounting Periods',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' },
      { key: 'status', name: 'Status' },
      { key: 'startDate', name: 'Start Date' },
      { key: 'endDate', name: 'End Date' }
    ]
  },
  'accounting.account': {
    label: 'Accounting / Account',
    nickname: 'Account',
    nicknamePlural: 'Accounts',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' },
      { key: 'description', name: 'Description' },
      { key: 'classification', name: 'Classification' },
      { key: 'type', name: 'Type (Deprecated)' },
      { key: 'accountType', name: 'Account Type' },
      { key: 'status', name: 'Status' },
      { key: 'currentBalance', name: 'Current Balance' },
      { key: 'currency', name: 'Currency' },
      { key: 'accountNumber', name: 'Account Number' },
      { key: 'parentAccount', name: 'Parent Account' },
      { key: 'company', name: 'Company' }
    ]
  },
  'accounting.address': {
    label: 'Accounting / Address',
    nickname: 'Address',
    nicknamePlural: 'Addresses',
    category: 'Accounting',
    fields: [
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'type', name: 'Type' },
      { key: 'street1', name: 'Street 1' },
      { key: 'street2', name: 'Street 2' },
      { key: 'city', name: 'City' },
      { key: 'state', name: 'State' },
      { key: 'countrySubdivision', name: 'Country Subdivision' },
      { key: 'country', name: 'Country' },
      { key: 'zipCode', name: 'Zip Code' }
    ]
  },
  'accounting.attachment': {
    label: 'Accounting / Attachment',
    nickname: 'Attachment',
    nicknamePlural: 'Attachments',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'fileName', name: 'File Name' },
      { key: 'fileUrl', name: 'File URL' },
      { key: 'company', name: 'Company' },
      { key: 'remoteWasDeleted', name: 'Remote Was Deleted' }
    ]
  },
  'accounting.balanceSheet': {
    label: 'Accounting / Balance Sheet',
    nickname: 'Balance Sheet',
    nicknamePlural: 'Balance Sheets',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' },
      { key: 'currency', name: 'Currency' },
      { key: 'company', name: 'Company' },
      { key: 'date', name: 'Date' },
      { key: 'netAssets', name: 'Net Assets' },
      { key: 'remoteGeneratedAt', name: 'Remote Generated At' },
      { key: 'assets', name: 'Assets' },
      { key: 'liabilities', name: 'Liabilities' },
      { key: 'equity', name: 'Equity' }
    ]
  },
  'accounting.bankFeedAccount': {
    label: 'Accounting / Bank Feed Account',
    nickname: 'Bank Feed Account',
    nicknamePlural: 'Bank Feed Accounts',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'sourceAccountId', name: 'Source Account ID' },
      { key: 'targetAccountId', name: 'Target Account ID' },
      { key: 'sourceAccountName', name: 'Source Account Name' },
      { key: 'sourceAccountNumber', name: 'Source Account Number' },
      { key: 'targetAccountName', name: 'Target Account Name' },
      { key: 'currency', name: 'Currency' },
      { key: 'feedStatus', name: 'Feed Status' },
      { key: 'feedStartDate', name: 'Feed Start Date' },
      { key: 'sourceAccountBalance', name: 'Source Account Balance' },
      { key: 'accountType', name: 'Account Type' }
    ]
  },
  'accounting.bankFeedTransaction': {
    label: 'Accounting / Bank Feed Transaction',
    nickname: 'Bank Feed Transaction',
    nicknamePlural: 'Bank Feed Transactions',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'bankFeedAccount', name: 'Bank Feed Account' },
      { key: 'transactionDate', name: 'Transaction Date' },
      { key: 'postedDate', name: 'Posted Date' },
      { key: 'amount', name: 'Amount' },
      { key: 'description', name: 'Description' },
      { key: 'transactionType', name: 'Transaction Type' },
      { key: 'payee', name: 'Payee' },
      { key: 'creditOrDebit', name: 'Credit or Debit' },
      { key: 'sourceTransactionId', name: 'Source Transaction ID' }
    ]
  },
  'accounting.cashFlowStatement': {
    label: 'Accounting / Cash Flow Statement',
    nickname: 'Cash Flow Statement',
    nicknamePlural: 'Cash Flow Statements',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' },
      { key: 'currency', name: 'Currency' },
      { key: 'company', name: 'Company' },
      { key: 'startPeriod', name: 'Start Period' },
      { key: 'endPeriod', name: 'End Period' },
      { key: 'cashAtBeginningOfPeriod', name: 'Cash at Beginning of Period' },
      { key: 'cashAtEndOfPeriod', name: 'Cash at End of Period' },
      { key: 'operatingActivities', name: 'Operating Activities' },
      { key: 'investingActivities', name: 'Investing Activities' },
      { key: 'financingActivities', name: 'Financing Activities' },
      { key: 'remoteGeneratedAt', name: 'Remote Generated At' }
    ]
  },
  'accounting.companyInfo': {
    label: 'Accounting / Company Info',
    nickname: 'Company Info',
    nicknamePlural: 'Company Infos',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' },
      { key: 'legalName', name: 'Legal Name' },
      { key: 'taxNumber', name: 'Tax Number' },
      { key: 'fiscalYearEndMonth', name: 'Fiscal Year End Month' },
      { key: 'fiscalYearEndDay', name: 'Fiscal Year End Day' },
      { key: 'currency', name: 'Currency' },
      { key: 'remoteCreatedAt', name: 'Remote Created At' },
      { key: 'urls', name: 'URLs' },
      { key: 'addresses', name: 'Addresses' },
      { key: 'phoneNumbers', name: 'Phone Numbers' }
    ]
  },
  'accounting.contact': {
    label: 'Accounting / Contact',
    nickname: 'Contact',
    nicknamePlural: 'Contacts',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' },
      { key: 'isSupplier', name: 'Is Supplier' },
      { key: 'isCustomer', name: 'Is Customer' },
      { key: 'emailAddress', name: 'Email Address' },
      { key: 'taxNumber', name: 'Tax Number' },
      { key: 'status', name: 'Status' },
      { key: 'currency', name: 'Currency' },
      { key: 'remoteUpdatedAt', name: 'Remote Updated At' },
      { key: 'company', name: 'Company' },
      { key: 'addresses', name: 'Addresses' },
      { key: 'phoneNumbers', name: 'Phone Numbers' }
    ]
  },
  'accounting.creditNote': {
    label: 'Accounting / Credit Note',
    nickname: 'Credit Note',
    nicknamePlural: 'Credit Notes',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'transactionDate', name: 'Transaction Date' },
      { key: 'status', name: 'Status' },
      { key: 'number', name: 'Number' },
      { key: 'contact', name: 'Contact' },
      { key: 'company', name: 'Company' },
      { key: 'exchangeRate', name: 'Exchange Rate' },
      { key: 'totalAmount', name: 'Total Amount' },
      { key: 'remainingCredit', name: 'Remaining Credit' },
      { key: 'inclusiveOfTax', name: 'Inclusive of Tax' },
      { key: 'lineItems', name: 'Line Items' },
      { key: 'trackingCategories', name: 'Tracking Categories' },
      { key: 'currency', name: 'Currency' },
      { key: 'remoteCreatedAt', name: 'Remote Created At' },
      { key: 'remoteUpdatedAt', name: 'Remote Updated At' },
      { key: 'payments', name: 'Payments' },
      { key: 'appliedPayments', name: 'Applied Payments' },
      { key: 'accountingPeriod', name: 'Accounting Period' },
      { key: 'appliedToLines', name: 'Applied To Lines' }
    ]
  },
  'accounting.employee': {
    label: 'Accounting / Employee',
    nickname: 'Employee',
    nicknamePlural: 'Employees',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'firstName', name: 'First Name' },
      { key: 'lastName', name: 'Last Name' },
      { key: 'isContractor', name: 'Is Contractor' },
      { key: 'employeeNumber', name: 'Employee Number' },
      { key: 'emailAddress', name: 'Email Address' },
      { key: 'company', name: 'Company' },
      { key: 'status', name: 'Status' }
    ]
  },
  'accounting.expenseReport': {
    label: 'Accounting / Expense Report',
    nickname: 'Expense Report',
    nicknamePlural: 'Expense Reports',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'reportDate', name: 'Report Date' },
      { key: 'reportIdentifier', name: 'Report Identifier' },
      { key: 'employee', name: 'Employee' },
      { key: 'status', name: 'Status' },
      { key: 'totalAmount', name: 'Total Amount' },
      { key: 'lines', name: 'Lines' },
      { key: 'currency', name: 'Currency' },
      { key: 'description', name: 'Description' },
      { key: 'accountingPeriod', name: 'Accounting Period' },
      { key: 'company', name: 'Company' },
      { key: 'trackingCategories', name: 'Tracking Categories' }
    ]
  },
  'accounting.expense': {
    label: 'Accounting / Expense',
    nickname: 'Expense',
    nicknamePlural: 'Expenses',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'transactionDate', name: 'Transaction Date' },
      { key: 'remoteCreatedAt', name: 'Remote Created At' },
      { key: 'account', name: 'Account' },
      { key: 'contact', name: 'Contact' },
      { key: 'totalAmount', name: 'Total Amount' },
      { key: 'subTotal', name: 'Sub Total' },
      { key: 'totalTaxAmount', name: 'Total Tax Amount' },
      { key: 'currency', name: 'Currency' },
      { key: 'exchangeRate', name: 'Exchange Rate' },
      { key: 'inclusiveOfTax', name: 'Inclusive of Tax' },
      { key: 'company', name: 'Company' },
      { key: 'employee', name: 'Employee' },
      { key: 'memo', name: 'Memo' },
      { key: 'lines', name: 'Lines' },
      { key: 'trackingCategories', name: 'Tracking Categories' }
    ]
  },
  'accounting.generalLedgerTransaction': {
    label: 'Accounting / General Ledger Transaction',
    nickname: 'General Ledger Transaction',
    nicknamePlural: 'General Ledger Transactions',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'underlyingTransactionRemoteId', name: 'Underlying Transaction Remote ID' },
      { key: 'underlyingTransactionType', name: 'Underlying Transaction Type' },
      { key: 'accountingPeriod', name: 'Accounting Period' },
      { key: 'company', name: 'Company' },
      { key: 'remoteUpdatedAt', name: 'Remote Updated At' },
      { key: 'remoteCreatedAt', name: 'Remote Created At' },
      { key: 'trackingCategories', name: 'Tracking Categories' },
      { key: 'postingDate', name: 'Posting Date' },
      { key: 'generalLedgerTransactionLines', name: 'General Ledger Transaction Lines' }
    ]
  },
  'accounting.incomeStatement': {
    label: 'Accounting / Income Statement',
    nickname: 'Income Statement',
    nicknamePlural: 'Income Statements',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' },
      { key: 'currency', name: 'Currency' },
      { key: 'company', name: 'Company' },
      { key: 'startPeriod', name: 'Start Period' },
      { key: 'endPeriod', name: 'End Period' },
      { key: 'income', name: 'Income' },
      { key: 'costOfSales', name: 'Cost of Sales' },
      { key: 'grossProfit', name: 'Gross Profit' },
      { key: 'operatingExpenses', name: 'Operating Expenses' },
      { key: 'netOperatingIncome', name: 'Net Operating Income' },
      { key: 'nonOperatingExpenses', name: 'Non Operating Expenses' },
      { key: 'netIncome', name: 'Net Income' }
    ]
  },
  'accounting.journalEntry': {
    label: 'Accounting / Journal Entry',
    nickname: 'Journal Entry',
    nicknamePlural: 'Journal Entries',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'transactionDate', name: 'Transaction Date' },
      { key: 'payments', name: 'Payments' },
      { key: 'appliedPayments', name: 'Applied Payments' },
      { key: 'memo', name: 'Memo' },
      { key: 'currency', name: 'Currency' },
      { key: 'exchangeRate', name: 'Exchange Rate' },
      { key: 'company', name: 'Company' },
      { key: 'inclusiveOfTax', name: 'Inclusive of Tax' },
      { key: 'lines', name: 'Lines' },
      { key: 'journalNumber', name: 'Journal Number' },
      { key: 'trackingCategories', name: 'Tracking Categories' }
    ]
  },
  'accounting.paymentMethod': {
    label: 'Accounting / Payment Method',
    nickname: 'Payment Method',
    nicknamePlural: 'Payment Methods',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'methodType', name: 'Method Type' },
      { key: 'name', name: 'Name' },
      { key: 'isActive', name: 'Is Active' },
      { key: 'remoteUpdatedAt', name: 'Remote Updated At' }
    ]
  },
  'accounting.paymentTerm': {
    label: 'Accounting / Payment Term',
    nickname: 'Payment Term',
    nicknamePlural: 'Payment Terms',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' },
      { key: 'isActive', name: 'Is Active' },
      { key: 'company', name: 'Company' },
      { key: 'daysUntilDue', name: 'Days Until Due' },
      { key: 'discountDays', name: 'Discount Days' },
      { key: 'remoteLastModifiedAt', name: 'Remote Last Modified At' }
    ]
  },
  'accounting.phoneNumber': {
    label: 'Accounting / Phone Number',
    nickname: 'Phone Number',
    nicknamePlural: 'Phone Numbers',
    category: 'Accounting',
    fields: [
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'number', name: 'Number' },
      { key: 'type', name: 'Type' }
    ]
  },
  'accounting.project': {
    label: 'Accounting / Project',
    nickname: 'Project',
    nicknamePlural: 'Projects',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' },
      { key: 'isActive', name: 'Is Active' },
      { key: 'company', name: 'Company' },
      { key: 'contact', name: 'Contact' }
    ]
  },
  'accounting.taxRate': {
    label: 'Accounting / Tax Rate',
    nickname: 'Tax Rate',
    nicknamePlural: 'Tax Rates',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'company', name: 'Company' },
      { key: 'code', name: 'Code' },
      { key: 'name', name: 'Name' },
      { key: 'description', name: 'Description' },
      { key: 'status', name: 'Status' },
      { key: 'country', name: 'Country' },
      { key: 'totalTaxRate', name: 'Total Tax Rate' },
      { key: 'effectiveTaxRate', name: 'Effective Tax Rate' },
      { key: 'taxComponents', name: 'Tax Components' }
    ]
  },
  'accounting.trackingCategory': {
    label: 'Accounting / Tracking Category',
    nickname: 'Tracking Category',
    nicknamePlural: 'Tracking Categories',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' },
      { key: 'status', name: 'Status' },
      { key: 'categoryType', name: 'Category Type' },
      { key: 'parentCategory', name: 'Parent Category' },
      { key: 'company', name: 'Company' }
    ]
  },
  'accounting.vendorCredit': {
    label: 'Accounting / Vendor Credit',
    nickname: 'Vendor Credit',
    nicknamePlural: 'Vendor Credits',
    category: 'Accounting',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'number', name: 'Number' },
      { key: 'transactionDate', name: 'Transaction Date' },
      { key: 'vendor', name: 'Vendor' },
      { key: 'totalAmount', name: 'Total Amount' },
      { key: 'currency', name: 'Currency' },
      { key: 'exchangeRate', name: 'Exchange Rate' },
      { key: 'inclusiveOfTax', name: 'Inclusive of Tax' },
      { key: 'company', name: 'Company' },
      { key: 'lines', name: 'Lines' },
      { key: 'trackingCategories', name: 'Tracking Categories' },
      { key: 'appliedToLines', name: 'Applied To Lines' }
    ]
  },
  'commerce.catalog': {
    label: 'Commerce / Catalog',
    nickname: 'Catalog',
    nicknamePlural: 'Catalogs',
    category: 'Commerce',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'updatedAt', name: 'Updated At' },
      { key: 'name', name: 'Name' },
      { key: 'description', name: 'Description' },
      { key: 'status', name: 'Status' },
      { key: 'currency', name: 'Currency' },
      { key: 'productCount', name: 'Product Count' },
      { key: 'lastSyncedAt', name: 'Last Synced At' }
    ]
  },
  'commerce.inventory': {
    label: 'Commerce / Inventory',
    nickname: 'Inventory',
    nicknamePlural: 'Inventories',
    category: 'Commerce',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'updatedAt', name: 'Updated At' },
      { key: 'productId', name: 'Product ID' },
      { key: 'variantId', name: 'Variant ID' },
      { key: 'warehouseId', name: 'Warehouse ID' },
      { key: 'quantity', name: 'Quantity' },
      { key: 'availableQuantity', name: 'Available Quantity' },
      { key: 'reservedQuantity', name: 'Reserved Quantity' },
      { key: 'lastStockUpdateAt', name: 'Last Stock Update At' }
    ]
  },
  'commerce.product': {
    label: 'Commerce / Product',
    nickname: 'Product',
    nicknamePlural: 'Products',
    category: 'Commerce',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' }, //
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'description', name: 'Description' },
      { key: 'productUrl', name: 'Product URL' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' }
    ]
  },
  'commerce.productVariant': {
    label: 'Commerce / Product Variant',
    nickname: 'Product Variant',
    nicknamePlural: 'Product Variants',
    category: 'Commerce',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' }, //
      { key: 'parentId', name: 'Parent ID' }, //
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'description', name: 'Description' },
      { key: 'productUrl', name: 'Product URL' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' }
    ]
  },
  'crm.contact': {
    label: 'CRM / Contact',
    nickname: 'Contact',
    nicknamePlural: 'Contacts',
    category: 'CRM',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'firstName', name: 'First Name' },
      { key: 'lastName', name: 'Last Name' },
      { key: 'emailAddress', name: 'Email Address' },
      { key: 'phoneNumber', name: 'Phone Number' },
      { key: 'lastActivityAt', name: 'Last Activity At' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'updatedAt', name: 'Updated At' },
      { key: 'deleted', name: 'Deleted' }
    ]
  },
  'crm.deal': {
    label: 'CRM / Deal',
    nickname: 'Deal',
    nicknamePlural: 'Deals',
    category: 'CRM',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' },
      { key: 'description', name: 'Description' },
      { key: 'amount', name: 'Amount' },
      { key: 'owner', name: 'Owner' },
      { key: 'account', name: 'Account' },
      { key: 'stage', name: 'Stage' },
      { key: 'status', name: 'Status' },
      { key: 'closeDate', name: 'Close Date' },
      { key: 'lastActivityAt', name: 'Last Activity At' },
      { key: 'probability', name: 'Probability' },
      { key: 'expectedRevenue', name: 'Expected Revenue' }
    ]
  },
  'crm.item': {
    label: 'CRM / Item',
    nickname: 'Item',
    nicknamePlural: 'Items',
    category: 'CRM',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'updatedAt', name: 'Updated At' },
      { key: 'name', name: 'Name' }
    ]
  },
  'crm.lead': {
    label: 'CRM / Lead',
    nickname: 'Lead',
    nicknamePlural: 'Leads',
    category: 'CRM',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'owner', name: 'Owner' },
      { key: 'leadSource', name: 'Lead Source' },
      { key: 'title', name: 'Title' },
      { key: 'company', name: 'Company' },
      { key: 'firstName', name: 'First Name' },
      { key: 'lastName', name: 'Last Name' },
      { key: 'address', name: 'Address' },
      { key: 'emailAddress', name: 'Email Address' },
      { key: 'phoneNumber', name: 'Phone Number' },
      { key: 'updatedAt', name: 'Updated At' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'convertedDate', name: 'Converted Date' },
      { key: 'convertedContact', name: 'Converted Contact' }
    ]
  },
  'crm.opportunity': {
    label: 'CRM / Opportunity',
    nickname: 'Opportunity',
    nicknamePlural: 'Opportunities',
    category: 'CRM',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' },
      { key: 'description', name: 'Description' },
      { key: 'amount', name: 'Amount' },
      { key: 'owner', name: 'Owner' },
      { key: 'account', name: 'Account' },
      { key: 'stage', name: 'Stage' },
      { key: 'status', name: 'Status' },
      { key: 'closeDate', name: 'Close Date' },
      { key: 'lastActivityAt', name: 'Last Activity At' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'updatedAt', name: 'Updated At' }
    ]
  },
  'crm.project': {
    label: 'CRM / Project',
    nickname: 'Project',
    nicknamePlural: 'Projects',
    category: 'CRM',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'updatedAt', name: 'Updated At' },
      { key: 'name', name: 'Name' },
      { key: 'description', name: 'Description' },
      { key: 'type', name: 'Type' }
    ]
  },
  'crm.report': {
    label: 'CRM / Report',
    nickname: 'Report',
    nicknamePlural: 'Reports',
    category: 'CRM',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'updatedAt', name: 'Updated At' },
      { key: 'name', name: 'Name' },
      { key: 'description', name: 'Description' },
      { key: 'type', name: 'Type' },
      { key: 'owner', name: 'Owner' },
      { key: 'isDeleted', name: 'Is Deleted' },
      { key: 'status', name: 'Status' }
    ]
  },
  'crm.task': {
    label: 'CRM / Task',
    nickname: 'Task',
    nicknamePlural: 'Tasks',
    category: 'CRM',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'subject', name: 'Subject' },
      { key: 'content', name: 'Content' },
      { key: 'owner', name: 'Owner' },
      { key: 'opportunity', name: 'Opportunity' },
      { key: 'completedDate', name: 'Completed Date' },
      { key: 'dueDate', name: 'Due Date' },
      { key: 'status', name: 'Status' }
    ]
  },
  'crm.user': {
    label: 'CRM / User',
    nickname: 'User',
    nicknamePlural: 'Users',
    category: 'CRM',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' },
      { key: 'email', name: 'Email' },
      { key: 'isActive', name: 'Is Active' },
      { key: 'image', name: 'Image URL' }
    ]
  },
  'crm.company': {
    label: 'CRM / Company',
    nickname: 'Company',
    nicknamePlural: 'Companies',
    category: 'CRM',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'updatedAt', name: 'Updated At' },
      { key: 'name', name: 'Name' }
    ]
  },
  'crm.engagementTypes': {
    label: 'CRM / Engagement Type',
    nickname: 'Engagement Type',
    nicknamePlural: 'Engagement Types',
    category: 'CRM',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'activityType', name: 'Activity Type' },
      { key: 'name', name: 'Name' },
      { key: 'remoteFields', name: 'Remote Fields' }
    ]
  },
  'crm.engagements': {
    label: 'CRM / Engagement',
    nickname: 'Engagement',
    nicknamePlural: 'Engagements',
    category: 'CRM',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'owner', name: 'Owner' },
      { key: 'content', name: 'Content' },
      { key: 'subject', name: 'Subject' },
      { key: 'direction', name: 'Direction' },
      { key: 'engagementType', name: 'Engagement Type' },
      { key: 'startTime', name: 'Start Time' },
      { key: 'endTime', name: 'End Time' },
      { key: 'account', name: 'Account' },
      { key: 'contacts', name: 'Contacts' }
    ]
  },
  'crm.notes': {
    label: 'CRM / Note',
    nickname: 'Note',
    nicknamePlural: 'Notes',
    category: 'CRM',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'owner', name: 'Owner' },
      { key: 'content', name: 'Content' },
      { key: 'contact', name: 'Contact' },
      { key: 'account', name: 'Account' },
      { key: 'opportunity', name: 'Opportunity' },
      { key: 'remoteUpdatedAt', name: 'Remote Updated At' },
      { key: 'remoteCreatedAt', name: 'Remote Created At' }
    ]
  },
  'crm.stages': {
    label: 'CRM / Stage',
    nickname: 'Stage',
    nicknamePlural: 'Stages',
    category: 'CRM',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' }
    ]
  },
  'marketing.appointment': {
    label: 'Marketing / Appointment',
    nickname: 'Appointment',
    nicknamePlural: 'Appointments',
    category: 'Marketing',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'updatedAt', name: 'Updated At' },
      { key: 'name', name: 'Name' },
      { key: 'startTime', name: 'Start Time' },
      { key: 'endTime', name: 'End Time' },
      { key: 'location', name: 'Location' },
      { key: 'description', name: 'Description' },
      { key: 'attendees', name: 'Attendees' },
      { key: 'organizer', name: 'Organizer' },
      { key: 'status', name: 'Status' },
      { key: 'type', name: 'Type' },
      { key: 'notes', name: 'Notes' },
      { key: 'reminder', name: 'Reminder' }
    ]
  },
  'marketing.campaign': {
    label: 'Marketing / Campaign',
    nickname: 'Campaign',
    nicknamePlural: 'Campaigns',
    category: 'Marketing',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'updatedAt', name: 'Updated At' },
      { key: 'name', name: 'Name' },
      { key: 'uniqueOpens', name: 'Unique Opens' },
      { key: 'remoteCreatedAt', name: 'Remote Created At' },
      { key: 'emailsSent', name: 'Emails Sent' }
    ]
  },
  'marketing.contact': {
    label: 'Marketing / Contact',
    nickname: 'Contact',
    nicknamePlural: 'Contacts',
    category: 'Marketing',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'updatedAt', name: 'Updated At' },
      { key: 'firstName', name: 'First Name' },
      { key: 'lastName', name: 'Last Name' },
      { key: 'email', name: 'Email' },
      { key: 'phone', name: 'Phone' },
      { key: 'state', name: 'State' },
      { key: 'country', name: 'Country' },
      { key: 'postalCode', name: 'Postal Code' }
    ]
  },
  'marketing.email': {
    label: 'Marketing / Email',
    nickname: 'Email',
    nicknamePlural: 'Emails',
    category: 'Marketing',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'updatedAt', name: 'Updated At' },
      { key: 'name', name: 'Name' },
      { key: 'subject', name: 'Subject' },
      { key: 'body', name: 'Body' },
      { key: 'htmlBody', name: 'HTML Body' },
      { key: 'fromName', name: 'From Name' },
      { key: 'fromEmail', name: 'From Email' },
      { key: 'preview', name: 'Preview' },
      { key: 'replyTo', name: 'Reply To' },
      { key: 'status', name: 'Status' },
      { key: 'sendDate', name: 'Send Date' },
      { key: 'template', name: 'Template' }
    ]
  },
  'marketing.event': {
    label: 'Marketing / Event',
    nickname: 'Event',
    nicknamePlural: 'Events',
    category: 'Marketing',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'updatedAt', name: 'Updated At' },
      { key: 'name', name: 'Name' },
      { key: 'description', name: 'Description' },
      { key: 'emails', name: 'Emails' },
      { key: 'messages', name: 'Messages' },
      { key: 'startTime', name: 'Start Time' },
      { key: 'endTime', name: 'End Time' }
    ]
  },
  'marketing.list': {
    label: 'Marketing / List',
    nickname: 'List',
    nicknamePlural: 'Lists',
    category: 'Marketing',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'updatedAt', name: 'Updated At' },
      { key: 'name', name: 'Name' },
      { key: 'type', name: 'Type' },
      { key: 'contactCount', name: 'Contact Count' }
    ]
  },
  'dataExtraction.document': {
    label: 'Data Extraction / Document',
    nickname: 'Document',
    nicknamePlural: 'Documents',
    category: 'Data Extraction and Technical Knowledge',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' }, //
      { key: 'sourceUrl', name: 'Source URL' },
      { key: 'title', name: 'Title' },
      { key: 'content', name: 'Content' },
      { key: 'metadata', name: 'Metadata' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'updatedAt', name: 'Updated At' }
    ]
  },
  'teamMessaging.message': {
    label: 'Team Messaging / Message',
    nickname: 'Message',
    nicknamePlural: 'Messages',
    category: 'Marketing',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' }, //
      { key: 'message', name: 'Message' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'updatedAt', name: 'Updated At' },
      { key: 'modifiedAt', name: 'Modified At' }
    ]
  },
  'recruiting.activity': {
    label: 'Recruiting / Activity',
    nickname: 'Activity',
    nicknamePlural: 'Activities',
    category: 'Recruiting (ATS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'user', name: 'User' },
      { key: 'remoteCreatedAt', name: 'Remote Created At' },
      { key: 'activityType', name: 'Activity Type' },
      { key: 'subject', name: 'Subject' },
      { key: 'body', name: 'Body' },
      { key: 'visibility', name: 'Visibility' },
      { key: 'candidate', name: 'Candidate' }
    ]
  },
  'recruiting.application': {
    label: 'Recruiting / Application',
    nickname: 'Application',
    nicknamePlural: 'Applications',
    category: 'Recruiting (ATS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'candidate', name: 'Candidate' },
      { key: 'job', name: 'Job' },
      { key: 'appliedAt', name: 'Applied At' },
      { key: 'rejectedAt', name: 'Rejected At' },
      { key: 'offers', name: 'Offers' },
      { key: 'source', name: 'Source' },
      { key: 'creditedTo', name: 'Credited To' },
      { key: 'screeningQuestionAnswers', name: 'Screening Question Answers' },
      { key: 'currentStage', name: 'Current Stage' },
      { key: 'rejectReason', name: 'Reject Reason' }
    ]
  },
  'recruiting.attachment': {
    label: 'Recruiting / Attachment',
    nickname: 'Attachment',
    nicknamePlural: 'Attachments',
    category: 'Recruiting (ATS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'fileName', name: 'File Name' },
      { key: 'fileUrl', name: 'File URL' },
      { key: 'candidate', name: 'Candidate' },
      { key: 'attachmentType', name: 'Attachment Type' }
    ]
  },
  'recruiting.candidate': {
    label: 'Recruiting / Candidate',
    nickname: 'Candidate',
    nicknamePlural: 'Candidates',
    category: 'Recruiting (ATS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'firstName', name: 'First Name' },
      { key: 'lastName', name: 'Last Name' },
      { key: 'company', name: 'Company' },
      { key: 'title', name: 'Title' },
      { key: 'remoteCreatedAt', name: 'Remote Created At' },
      { key: 'remoteUpdatedAt', name: 'Remote Updated At' },
      { key: 'lastInteractionAt', name: 'Last Interaction At' },
      { key: 'isPrivate', name: 'Is Private' },
      { key: 'canEmail', name: 'Can Email' },
      { key: 'locations', name: 'Locations' },
      { key: 'phoneNumbers', name: 'Phone Numbers' },
      { key: 'emailAddresses', name: 'Email Addresses' },
      { key: 'urls', name: 'URLs' },
      { key: 'tags', name: 'Tags' },
      { key: 'applications', name: 'Applications' },
      { key: 'attachments', name: 'Attachments' }
    ]
  },
  'recruiting.department': {
    label: 'Recruiting / Department',
    nickname: 'Department',
    nicknamePlural: 'Departments',
    category: 'Recruiting (ATS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' }
    ]
  },
  'recruiting.eeoc': {
    label: 'Recruiting / EEOC',
    nickname: 'EEOC',
    nicknamePlural: 'Eeocs',
    category: 'Recruiting (ATS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'candidate', name: 'Candidate' },
      { key: 'submittedAt', name: 'Submitted At' },
      { key: 'race', name: 'Race' },
      { key: 'gender', name: 'Gender' },
      { key: 'veteranStatus', name: 'Veteran Status' },
      { key: 'disabilityStatus', name: 'Disability Status' }
    ]
  },
  'recruiting.interview': {
    label: 'Recruiting / Interview',
    nickname: 'Interview',
    nicknamePlural: 'Interviews',
    category: 'Recruiting (ATS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'application', name: 'Application' },
      { key: 'jobInterviewStage', name: 'Job Interview Stage' },
      { key: 'organizer', name: 'Organizer' },
      { key: 'interviewers', name: 'Interviewers' },
      { key: 'location', name: 'Location' },
      { key: 'startAt', name: 'Start At' },
      { key: 'endAt', name: 'End At' },
      { key: 'remoteCreatedAt', name: 'Remote Created At' },
      { key: 'remoteUpdatedAt', name: 'Remote Updated At' },
      { key: 'status', name: 'Status' }
    ]
  },
  'recruiting.jobInterviewStage': {
    label: 'Recruiting / Job Interview Stage',
    nickname: 'Job Interview Stage',
    nicknamePlural: 'Job Interview Stages',
    category: 'Recruiting (ATS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' },
      { key: 'job', name: 'Job' },
      { key: 'stageOrder', name: 'Stage Order' }
    ]
  },
  'recruiting.jobPosting': {
    label: 'Recruiting / Job Posting',
    nickname: 'Job Posting',
    nicknamePlural: 'Job Postings',
    category: 'Recruiting (ATS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'title', name: 'Title' },
      { key: 'jobPostingUrls', name: 'Job Posting URLs' },
      { key: 'job', name: 'Job' },
      { key: 'status', name: 'Status' },
      { key: 'content', name: 'Content' },
      { key: 'remoteCreatedAt', name: 'Remote Created At' },
      { key: 'remoteUpdatedAt', name: 'Remote Updated At' },
      { key: 'isInternal', name: 'Is Internal' }
    ]
  },
  'recruiting.job': {
    label: 'Recruiting / Job',
    nickname: 'Job',
    nicknamePlural: 'Jobs',
    category: 'Recruiting (ATS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' },
      { key: 'description', name: 'Description' },
      { key: 'code', name: 'Code' },
      { key: 'status', name: 'Status' },
      { key: 'type', name: 'Type' },
      { key: 'jobPostings', name: 'Job Postings' },
      { key: 'jobPostingUrls', name: 'Job Posting URLs' },
      { key: 'remoteCreatedAt', name: 'Remote Created At' },
      { key: 'remoteUpdatedAt', name: 'Remote Updated At' },
      { key: 'confidential', name: 'Confidential' },
      { key: 'departments', name: 'Departments' },
      { key: 'offices', name: 'Offices' },
      { key: 'hiringManagers', name: 'Hiring Managers' },
      { key: 'recruiters', name: 'Recruiters' }
    ]
  },
  'recruiting.offer': {
    label: 'Recruiting / Offer',
    nickname: 'Offer',
    nicknamePlural: 'Offers',
    category: 'Recruiting (ATS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'application', name: 'Application' },
      { key: 'creator', name: 'Creator' },
      { key: 'remoteCreatedAt', name: 'Remote Created At' },
      { key: 'closedAt', name: 'Closed At' },
      { key: 'sentAt', name: 'Sent At' },
      { key: 'startDate', name: 'Start Date' },
      { key: 'status', name: 'Status' }
    ]
  },
  'recruiting.office': {
    label: 'Recruiting / Office',
    nickname: 'Office',
    nicknamePlural: 'Offices',
    category: 'Recruiting (ATS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' },
      { key: 'location', name: 'Location' }
    ]
  },
  'recruiting.rejectReason': {
    label: 'Recruiting / Reject Reason',
    nickname: 'Reject Reason',
    nicknamePlural: 'Reject Reasons',
    category: 'Recruiting (ATS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' }
    ]
  },
  'recruiting.scorecard': {
    label: 'Recruiting / Scorecard',
    nickname: 'Scorecard',
    nicknamePlural: 'Scorecards',
    category: 'Recruiting (ATS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'application', name: 'Application' },
      { key: 'interview', name: 'Interview' },
      { key: 'interviewer', name: 'Interviewer' },
      { key: 'remoteCreatedAt', name: 'Remote Created At' },
      { key: 'submittedAt', name: 'Submitted At' },
      { key: 'overallRecommendation', name: 'Overall Recommendation' }
    ]
  },
  'recruiting.screeningQuestion': {
    label: 'Recruiting / Screening Question',
    nickname: 'Screening Question',
    nicknamePlural: 'Screening Questions',
    category: 'Recruiting (ATS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'job', name: 'Job' },
      { key: 'description', name: 'Description' },
      { key: 'title', name: 'Title' },
      { key: 'type', name: 'Type' },
      { key: 'required', name: 'Required' },
      { key: 'options', name: 'Options' }
    ]
  },
  'recruiting.tag': {
    label: 'Recruiting / Tag',
    nickname: 'Tag',
    nicknamePlural: 'Tags',
    category: 'Recruiting (ATS)',
    fields: [
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' }
    ]
  },
  'recruiting.user': {
    label: 'Recruiting / User',
    nickname: 'User',
    nicknamePlural: 'Users',
    category: 'Recruiting (ATS)',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'firstName', name: 'First Name' },
      { key: 'lastName', name: 'Last Name' },
      { key: 'email', name: 'Email' },
      { key: 'disabled', name: 'Disabled' },
      { key: 'remoteCreatedAt', name: 'Remote Created At' },
      { key: 'accessRole', name: 'Access Role' }
    ]
  },
  'storage.file': {
    label: 'Storage / File',
    nickname: 'File',
    nicknamePlural: 'Files',
    category: 'Storage',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'updatedAt', name: 'Updated At' },
      { key: 'name', name: 'Name' },
      { key: 'fileUrl', name: 'File URL' },
      { key: 'size', name: 'Size' },
      { key: 'mimeType', name: 'MIME Type' },
      { key: 'description', name: 'Description' },
      { key: 'folder', name: 'Folder' }
    ]
  },
  'storage.folder': {
    label: 'Storage / Folder',
    nickname: 'Folder',
    nicknamePlural: 'Folders',
    category: 'Storage',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'updatedAt', name: 'Updated At' },
      { key: 'name', name: 'Name' },
      { key: 'folderUrl', name: 'Folder URL' },
      { key: 'size', name: 'Size' },
      { key: 'description', name: 'Description' },
      { key: 'parentFolder', name: 'Parent Folder' }
    ]
  },
  'storage.drives': {
    label: 'Storage / Drives',
    nickname: 'Drive',
    nicknamePlural: 'Drives',
    category: 'Storage',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' },
      { key: 'description', name: 'Description' },
      { key: 'totalSpace', name: 'Total Space' },
      { key: 'usedSpace', name: 'Used Space' },
      { key: 'availableSpace', name: 'Available Space' },
      { key: 'driveType', name: 'Drive Type' },
      { key: 'isActive', name: 'Is Active' }
    ]
  },
  'storage.groups': {
    label: 'Storage / Groups',
    nickname: 'Group',
    nicknamePlural: 'Groups',
    category: 'Storage',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' },
      { key: 'description', name: 'Description' },
      { key: 'permissions', name: 'Permissions' },
      { key: 'memberCount', name: 'Member Count' },
      { key: 'isActive', name: 'Is Active' }
    ]
  },
  'storage.users': {
    label: 'Storage / Users',
    nickname: 'User',
    nicknamePlural: 'Users',
    category: 'Storage',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' },
      { key: 'emailAddress', name: 'Email Address' },
      { key: 'isActive', name: 'Is Active' },
      { key: 'groups', name: 'Groups' },
      { key: 'permissions', name: 'Permissions' },
      { key: 'avatar', name: 'Avatar' }
    ]
  },
  'ticketing.collection': {
    label: 'Ticketing / Collection',
    nickname: 'Collection',
    nicknamePlural: 'Collections',
    category: 'Ticketing',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'updatedAt', name: 'Updated At' },
      { key: 'name', name: 'Name' },
      { key: 'description', name: 'Description' }
    ]
  },
  'ticketing.comment': {
    label: 'Ticketing / Comment',
    nickname: 'Comment',
    nicknamePlural: 'Comments',
    category: 'Ticketing',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'updatedAt', name: 'Updated At' },
      { key: 'contact', name: 'Contact' },
      { key: 'body', name: 'Body' },
      { key: 'htmlBody', name: 'HTML Body' },
      { key: 'ticket', name: 'Ticket' },
      { key: 'isPrivate', name: 'Is Private' }
    ]
  },
  'ticketing.contact': {
    label: 'Ticketing / Contact',
    nickname: 'Contact',
    nicknamePlural: 'Contacts',
    category: 'Ticketing',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'updatedAt', name: 'Updated At' },
      { key: 'name', name: 'Name' },
      { key: 'emailAddress', name: 'Email Address' },
      { key: 'phoneNumber', name: 'Phone Number' },
      { key: 'details', name: 'Details' }
    ]
  },
  'ticketing.ticket': {
    label: 'Ticketing / Ticket',
    nickname: 'Ticket',
    nicknamePlural: 'Tickets',
    category: 'Ticketing',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'updatedAt', name: 'Updated At' },
      { key: 'name', name: 'Name' },
      { key: 'assignees', name: 'Assignees' },
      { key: 'creator', name: 'Creator' },
      { key: 'dueDate', name: 'Due Date' },
      { key: 'status', name: 'Status' },
      { key: 'description', name: 'Description' },
      { key: 'collections', name: 'Collections' },
      { key: 'ticketType', name: 'Ticket Type' },
      { key: 'attachments', name: 'Attachments' },
      { key: 'tags', name: 'Tags' },
      { key: 'completedAt', name: 'Completed At' }
    ]
  },
  'ticketing.accounts': {
    label: 'Ticketing / Accounts',
    nickname: 'Account',
    nicknamePlural: 'Accounts',
    category: 'Ticketing',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' },
      { key: 'domains', name: 'Domains' }
    ]
  },
  'ticketing.attachments': {
    label: 'Ticketing / Attachments',
    nickname: 'Attachment',
    nicknamePlural: 'Attachments',
    category: 'Ticketing',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'fileName', name: 'File Name' },
      { key: 'ticket', name: 'Ticket' },
      { key: 'fileUrl', name: 'File URL' },
      { key: 'contentType', name: 'Content Type' },
      { key: 'uploadedBy', name: 'Uploaded By' },
      { key: 'remoteCreatedAt', name: 'Remote Created At' }
    ]
  },
  'ticketing.roles': {
    label: 'Ticketing / Roles',
    nickname: 'Role',
    nicknamePlural: 'Roles',
    category: 'Ticketing',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' },
      { key: 'ticketActions', name: 'Ticket Actions' },
      { key: 'ticketAccess', name: 'Ticket Access' }
    ]
  },
  'ticketing.tags': {
    label: 'Ticketing / Tags',
    nickname: 'Tag',
    nicknamePlural: 'Tags',
    category: 'Ticketing',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' }
    ]
  },
  'ticketing.teams': {
    label: 'Ticketing / Teams',
    nickname: 'Team',
    nicknamePlural: 'Teams',
    category: 'Ticketing',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' },
      { key: 'description', name: 'Description' }
    ]
  },
  'ticketing.users': {
    label: 'Ticketing / Users',
    nickname: 'User',
    nicknamePlural: 'Users',
    category: 'Ticketing',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'name', name: 'Name' },
      { key: 'emailAddress', name: 'Email Address' },
      { key: 'isActive', name: 'Is Active' },
      { key: 'teams', name: 'Teams' },
      { key: 'roles', name: 'Roles' },
      { key: 'avatar', name: 'Avatar' }
    ]
  },
  'ticketing.viewers': {
    label: 'Ticketing / Viewers',
    nickname: 'Viewer',
    nicknamePlural: 'Viewers',
    category: 'Ticketing',
    fields: [
      { key: 'id', name: 'ID (Primary Key)' },
      { key: 'remoteId', name: 'Remote ID' },
      { key: 'createdAt', name: 'Created At' },
      { key: 'modifiedAt', name: 'Modified At' },
      { key: 'team', name: 'Team' },
      { key: 'user', name: 'User' }
    ]
  }
};

export const actionModelOptions = Object.entries(actionModels).map(([key, value]) => ({ label: value.label, value: key }));
